import _ from 'lodash';
import ContentLoader from 'react-content-loader';
import ProfileStore from '../stores/ProfileStore';

import { ReactComponent as MoneyIcon } from '@/img/money.svg';
import { useTranslation } from 'react-i18next';

const InstallmentsBanner = ({ isLoading, isRtl }) => {
	const { t } = useTranslation();
	const profile = ProfileStore.getProfile();

	const company_installments_iframe_enabled = _.get(profile, 'company.settings.installments_iframe_enabled', false);

	if (!company_installments_iframe_enabled) {
		return null;
	}

	if (isLoading) {
		return (
			<div>
				<ContentLoader width="770px" height="48px" rtl={isRtl}>
					<rect x="0" y="0" rx="8" ry="8" width="770px" height="48px" />
				</ContentLoader>
			</div>
		);
	}

	const installments_max_num = _.get(profile, 'company.settings.installments_max_num', 3);

	return (
		<div className="installments-banner">
			<div className="installments-banner__icon-wrap">
				<MoneyIcon />
			</div>
			<div className="installments-banner__text">{t('PayWithInstallments', { installments_max_num })}</div>
		</div>
	);
};

export default InstallmentsBanner;
